(function () {
  "use strict";

  const STATES = ["Clarity", "Unfolding", "Soothing", "Grounding", "Protection", "Courage"];
  const STATE_CN = {
    Clarity: "清明",
    Unfolding: "松弛",
    Soothing: "慰藉",
    Grounding: "安定",
    Protection: "护持",
    Courage: "勇气"
  };
  const STATE_LABEL_EN = {
    Clarity: "Clarity",
    Unfolding: "Unfolding",
    Soothing: "Soothing",
    Grounding: "Grounding",
    Protection: "Protection",
    Courage: "Courage"
  };

  const Q2_SCORES = {
    turning_inward: { Clarity: 6, Soothing: 4 },
    relationships: { Unfolding: 6, Soothing: 4 },
    forming_ideas: { Courage: 6, Clarity: 4 },
    daily_steadiness: { Grounding: 6, Soothing: 4 },
    caring_for_body: { Soothing: 6, Grounding: 6 },
    transition: { Clarity: 6, Courage: 4, Grounding: 2 },
    intuition: {},
    prefer_not_to_say: {}
  };

  const Q2_ALIAS = {
    "回到内在": "turning_inward",
    "关系之间": "relationships",
    "想法成形": "forming_ideas",
    "生活安稳": "daily_steadiness",
    "照顾身体": "caring_for_body",
    "走过转场": "transition",
    "跟随直觉": "intuition",
    "暂不说明": "prefer_not_to_say"
  };

  const Q3_DATA = {
    overwhelmed: {
      scores: { Soothing: 6, Grounding: 6, Unfolding: 2 },
      expression: { protection_expression: "container" },
      safety: "conservative",
      safety_tags: ["low_stimulation", "soothing_safe", "grounding_safe", "container_safe"]
    },
    scattered: {
      scores: { Grounding: 6, Protection: 6, Clarity: 4 },
      expression: { protection_expression: "boundary" },
      safety: "normal",
      safety_tags: ["boundary_safe", "grounding_safe"]
    },
    steady: { scores: {}, expression: {}, safety: "normal", safety_tags: [] },
    stuck: {
      scores: { Clarity: 6, Courage: 6, Unfolding: 4 },
      expression: { courage_expression: "gentle" },
      safety: "normal",
      safety_tags: ["gentle_courage_safe"]
    },
    low_energy: {
      scores: { Courage: 6, Unfolding: 6, Soothing: 4 },
      expression: { courage_expression: "gentle" },
      safety: "normal",
      safety_tags: ["gentle_courage_safe", "soft_safe", "soothing_safe"]
    }
  };

  const Q3_ALIAS = {
    "有点太满": "overwhelmed",
    "节奏有点乱": "scattered",
    "还算平稳": "steady",
    "有点卡住": "stuck",
    "有点没劲": "low_energy"
  };

  const ZODIAC_AFFINITY = {
    Aries: { Clarity: 15, Unfolding: 15, Soothing: 5, Grounding: 10, Protection: 10, Courage: 45 },
    Leo: { Clarity: 15, Unfolding: 25, Soothing: 5, Grounding: 10, Protection: 10, Courage: 35 },
    Sagittarius: { Clarity: 25, Unfolding: 25, Soothing: 5, Grounding: 5, Protection: 5, Courage: 35 },
    Taurus: { Clarity: 5, Unfolding: 15, Soothing: 20, Grounding: 35, Protection: 20, Courage: 5 },
    Virgo: { Clarity: 35, Unfolding: 15, Soothing: 5, Grounding: 25, Protection: 15, Courage: 5 },
    Capricorn: { Clarity: 15, Unfolding: 5, Soothing: 5, Grounding: 35, Protection: 30, Courage: 10 },
    Gemini: { Clarity: 30, Unfolding: 30, Soothing: 5, Grounding: 5, Protection: 5, Courage: 25 },
    Libra: { Clarity: 25, Unfolding: 20, Soothing: 25, Grounding: 5, Protection: 15, Courage: 10 },
    Aquarius: { Clarity: 35, Unfolding: 20, Soothing: 5, Grounding: 5, Protection: 20, Courage: 15 },
    Cancer: { Clarity: 5, Unfolding: 15, Soothing: 35, Grounding: 15, Protection: 25, Courage: 5 },
    Scorpio: { Clarity: 15, Unfolding: 5, Soothing: 15, Grounding: 15, Protection: 30, Courage: 20 },
    Pisces: { Clarity: 10, Unfolding: 30, Soothing: 40, Grounding: 5, Protection: 5, Courage: 10 }
  };

  const SEASON_VECTORS = {
    Wood: { Clarity: 5, Unfolding: 50, Soothing: 5, Grounding: 5, Protection: 5, Courage: 30 },
    Fire: { Clarity: 15, Unfolding: 15, Soothing: 0, Grounding: 5, Protection: 5, Courage: 60 },
    Metal: { Clarity: 45, Unfolding: 5, Soothing: 5, Grounding: 10, Protection: 35, Courage: 0 },
    Water: { Clarity: 10, Unfolding: 25, Soothing: 55, Grounding: 5, Protection: 5, Courage: 0 }
  };

  const ELEMENTS = ["Wood", "Fire", "Earth", "Metal", "Water"];
  const W_MATRIX = {
    Clarity: { Wood: 0, Fire: 15, Earth: 5, Metal: 70, Water: 10 },
    Unfolding: { Wood: 55, Fire: 10, Earth: 5, Metal: 0, Water: 30 },
    Soothing: { Wood: 0, Fire: 0, Earth: 20, Metal: 0, Water: 80 },
    Grounding: { Wood: 0, Fire: 5, Earth: 75, Metal: 15, Water: 5 },
    Protection: { Wood: 0, Fire: 5, Earth: 30, Metal: 60, Water: 5 },
    Courage: { Wood: 30, Fire: 65, Earth: 5, Metal: 0, Water: 0 }
  };
  const CONTROLLED_BY = { Wood: "Metal", Earth: "Wood", Water: "Earth", Fire: "Water", Metal: "Fire" };
  const GENERATES = { Wood: "Fire", Fire: "Earth", Earth: "Metal", Metal: "Water", Water: "Wood" };

  const VERSES = {
    "Clarity|Clarity": [1, "雾尽见山，不急问归处。"],
    "Clarity|Unfolding": [2, "镜开留白，心路自宽。"],
    "Clarity|Soothing": [3, "冷雾轻开，疲心渐明。"],
    "Clarity|Grounding": [4, "雪落见地，心知所立。"],
    "Clarity|Protection": [5, "镜中有界，纷影不侵。"],
    "Clarity|Courage": [6, "霜明见路，足下可行。"],
    "Unfolding|Unfolding": [7, "苇折能伸，松处自如。"],
    "Unfolding|Clarity": [8, "柳影初疏，心路渐清。"],
    "Unfolding|Soothing": [9, "春枝初展，先许心松。"],
    "Unfolding|Grounding": [10, "柔枝入土，松处有根。"],
    "Unfolding|Protection": [11, "柳过门前，风来不折。"],
    "Unfolding|Courage": [12, "新枝迎风，松处生力。"],
    "Soothing|Clarity": [13, "月照浅湾，心事渐明。"],
    "Soothing|Unfolding": [14, "潮声渐缓，心可慢松。"],
    "Soothing|Soothing": [15, "夜灯低照，疲心有归处。"],
    "Soothing|Grounding": [16, "浅湾有托，倦意可安。"],
    "Soothing|Protection": [17, "灯在门内，疲心可归。"],
    "Soothing|Courage": [18, "柔光不灭，倦心有温。"],
    "Grounding|Clarity": [19, "山骨在下，心路自清。"],
    "Grounding|Unfolding": [20, "土里春根，稳处亦展。"],
    "Grounding|Soothing": [21, "石上可坐，倦心有托。"],
    "Grounding|Grounding": [22, "深土承根，身有所依。"],
    "Grounding|Protection": [23, "山门静立，身有所安。"],
    "Grounding|Courage": [24, "根深路稳，步可向前。"],
    "Protection|Clarity": [25, "门开有度，心镜自清。"],
    "Protection|Unfolding": [26, "收檐成室，身心渐舒。"],
    "Protection|Soothing": [27, "门阖成室，内有微灯。"],
    "Protection|Grounding": [28, "墙立成界，可倚可居。"],
    "Protection|Protection": [29, "有所不受，清宁自守。"],
    "Protection|Courage": [30, "阈开有度，守中可行。"],
    "Courage|Clarity": [31, "火照前路，心知所向。"],
    "Courage|Unfolding": [32, "新芽逆风，柔中有进。"],
    "Courage|Soothing": [33, "余烬未冷，倦身可起。"],
    "Courage|Grounding": [34, "春芽破土，不问风声。"],
    "Courage|Protection": [35, "火守其界，行而知止。"],
    "Courage|Courage": [36, "微火在怀，仍可向前。"]
  };

  // Native-rewritten English verses (source of truth: english-version verses JSON).
  // Keyed by verse number so CN + EN stay paired and bilingual-equal on the page.
  const VERSE_TEXT_EN = {
    1: "The mist lifts; the mountain appears. No need yet to ask where the road ends.",
    2: "The mirror clears, leaving space; the path within grows wider.",
    3: "Cold mist begins to thin; the tired heart slowly clears.",
    4: "Snow settles and the earth appears; the heart knows where to stand.",
    5: "The mirror holds a clear edge; stray shadows do not cross.",
    6: "Frost brightens the path; the next step is ready beneath your feet.",
    7: "A reed bends and rises; ease lives in yielding.",
    8: "Willow shadows begin to thin; the path within grows clear.",
    9: "Spring branches begin to unfurl; let the heart loosen first.",
    10: "A tender branch meets the earth; ease, too, can take root.",
    11: "A willow stands by the doorway; the wind comes, but does not break it.",
    12: "A new branch meets the wind; strength grows from ease.",
    13: "Moonlight fills a quiet cove; what weighs on the heart grows clear.",
    14: "The tide grows quiet; the heart may loosen slowly.",
    15: "A low lamp glows at night; the tired heart has somewhere to return.",
    16: "A sheltered cove holds steady; weariness may come to rest.",
    17: "A light waits within the door; the tired heart may come home.",
    18: "The soft light endures; the weary heart is met with warmth.",
    19: "The mountain holds firm below; the path within grows clear.",
    20: "Spring roots stir in the earth; what is steady can still unfold.",
    21: "A stone offers a place to rest; the weary heart is held.",
    22: "Deep earth holds the roots; the body finds support.",
    23: "The mountain gate stands in silence; the body finds a place to settle.",
    24: "Roots run deep and the road holds steady; the next step can move forward.",
    25: "The door opens with care; the heart’s mirror clears.",
    26: "Draw in the eaves and a shelter takes shape; body and heart begin to ease.",
    27: "The door closes and the room becomes whole; a small light glows within.",
    28: "A wall marks the boundary; there is space to lean and stay.",
    29: "Some things need not enter; quiet clarity remains your own.",
    30: "The threshold opens just enough; from a steady center, movement is possible.",
    31: "Fire lights the road ahead; the heart knows where to go.",
    32: "A new shoot leans into the wind; softness still moves forward.",
    33: "The embers are still warm; the weary body can rise.",
    34: "A spring shoot breaks the earth; the wind need not decide.",
    35: "Fire keeps its boundary; move forward, knowing where to stop.",
    36: "A small flame rests within; forward is still possible."
  };

  const STATE_HEADLINE = {
    Clarity: "清透、干净、能让注意力慢慢聚焦的天然石作品。",
    Unfolding: "柔和、留白、能让状态慢慢舒展开的天然石作品。",
    Soothing: "温润、安静、能让疲惫慢慢停靠的天然石作品。",
    Grounding: "沉稳、有支撑感、能让心绪慢慢落地的天然石作品。",
    Protection: "内收、有边界感、能让能量慢慢收回来的天然石作品。",
    Courage: "带一点明亮启动感、但不强冲的天然石作品。"
  };

  const AESTHETIC_HEADLINE = {
    Clear_Clean_Bright: "光感清楚、质地干净",
    Scenic_Inclusion_World: "内里有景、层次可以慢慢看进去",
    Rutilated_Thread_Light: "线条与光感更有存在感",
    Raw_Cluster_Point: "保留天然结构和矿物形态",
    Soft_Glow_Luminous: "光感柔和、不强烈抢眼",
    Wood_Agarwood_Warm: "带木质暖意、温实日常",
    Intuitive_Eye_Led: "保留更多眼缘空间"
  };

  const CURRENT_REASON = {
    Clarity: "这次更适合清透、干净、能让注意力慢慢聚焦的作品。它不需要给出答案，而是让眼前的杂音先降下来。",
    Unfolding: "这次更适合柔和、不强冲、能让人慢慢松下来的作品。它不需要把你往前推，而是先给身心一点回旋的空间。",
    Soothing: "这次更适合安静、温润、能让人慢慢停靠的作品。它不急着推动变化，而是先给疲惫的部分一点安放。",
    Grounding: "这次更适合沉稳、有支撑感、能让人慢慢落地的作品。它不制造更多刺激，而是让状态先有一个着力点。",
    Protection: "这次更适合安静、内收、有边界感的作品。它不需要对抗外界，而是让自己的节奏先被好好收回来。",
    Courage: "这次更适合带一点明亮感和启动感、但不强冲的作品。它像一个温和的提醒，让行动慢慢回来。"
  };

  const AESTHETIC_REASON = {
    Clear_Clean_Bright: "你更容易被清透、干净的石头吸引，所以推荐会优先选择光感清楚、第一眼更利落的作品。",
    Scenic_Inclusion_World: "你更容易被“内里有景”的石头吸引，所以推荐会优先选择有层次、有景深、像小世界一样可以慢慢看进去的作品。",
    Rutilated_Thread_Light: "你更容易被发丝、光线或细密纹理吸引，所以推荐会优先选择内部线条有存在感、但不过分刺眼的作品。",
    Raw_Cluster_Point: "你更容易被原矿、簇状或柱体的天然形态吸引，所以推荐会保留一点矿物本身的野性和结构感。",
    Soft_Glow_Luminous: "你更容易被柔和光感吸引，所以推荐会优先选择温润、微亮、不强烈抢眼的作品。",
    Wood_Agarwood_Warm: "你更容易被木质、沉静、带暖意的材质吸引，所以推荐会优先选择更温实、更日常的作品。",
    Intuitive_Eye_Led: "这次审美选择更适合交给眼缘，所以推荐不会把视觉方向卡得太死；你可以先看哪一件让你停留更久。"
  };

  const DIRECTION_REASON = {
    Clarity: "想先弄清楚、让杂音少一点、看明白再靠近",
    Unfolding: "让紧绷的地方慢慢松开，给自己一点舒展余地",
    Soothing: "让疲惫的部分先被安放，不急着马上变好",
    Grounding: "重新站稳，让心和身体有一个着力点",
    Protection: "先收回自己，守住边界和不被打扰的空间",
    Courage: "在还没完全确定的时候，先往前一点点"
  };

  const STATE_HEADLINE_EN = {
    Clarity: "Clean light, clear structure, and pieces that let attention settle.",
    Unfolding: "Soft movement, open space, and pieces that feel easier to return to.",
    Soothing: "Gentle glow, quiet texture, and pieces with a calmer emotional pace.",
    Grounding: "Weight, warmth, and pieces that feel steady enough for daily wear.",
    Protection: "Defined edges, darker depth, and pieces that feel contained.",
    Courage: "A clearer spark and a little forward motion, without feeling forced."
  };

  const STATE_SUMMARY_EN = {
    Clarity: "Your answers point toward a clearer visual field: cleaner light, defined material, and pieces that do not ask for extra noise.",
    Unfolding: "Your answers point toward a softer opening: more room, less pressure, and pieces that let the eye move slowly.",
    Soothing: "Your answers point toward a quieter pace: softer color, calmer texture, and pieces that feel easy to stay with.",
    Grounding: "Your answers point toward steadiness: warmer materials, more weight, and pieces that can sit close to daily life.",
    Protection: "Your answers point toward a contained direction: stronger edges, deeper tones, and pieces that help the look feel held together.",
    Courage: "Your answers point toward gentle momentum: brighter accents, clearer contrast, and pieces that carry a small sense of action."
  };

  const AESTHETIC_LABEL_EN = {
    Clear_Clean_Bright: "clear, clean brightness",
    Scenic_Inclusion_World: "scenic inclusions and inner worlds",
    Rutilated_Thread_Light: "threads of light and visible texture",
    Raw_Cluster_Point: "raw mineral form",
    Soft_Glow_Luminous: "soft glow",
    Wood_Agarwood_Warm: "wood warmth",
    Intuitive_Eye_Led: "eye-led selection"
  };

  const CURRENT_REASON_EN = {
    Clarity: "The current-state answers lean toward clarity, so the match favors pieces with cleaner light, clearer material, and less visual friction.",
    Unfolding: "The current-state answers lean toward unfolding, so the match favors pieces that feel open, soft, and less tightly held.",
    Soothing: "The current-state answers lean toward soothing, so the match favors pieces with a calmer pace, gentler glow, and less sharp contrast.",
    Grounding: "The current-state answers lean toward grounding, so the match favors pieces with warmth, weight, and a more stable daily presence.",
    Protection: "The current-state answers lean toward protection, so the match favors pieces with contained color, defined edges, and a stronger sense of boundary.",
    Courage: "The current-state answers lean toward courage, so the match favors pieces with clearer contrast and a small sense of forward movement."
  };

  const AESTHETIC_REASON_EN = {
    Clear_Clean_Bright: "You chose clearer, cleaner stones, so the edit gives extra weight to transparent material, visible light, and a more refined first impression.",
    Scenic_Inclusion_World: "You chose stones with inner scenery, so the edit gives extra weight to inclusions, depth, and pieces that invite slower looking.",
    Rutilated_Thread_Light: "You chose threads, light, or fine texture, so the edit gives extra weight to visible internal lines and more active surfaces.",
    Raw_Cluster_Point: "You chose raw or mineral structure, so the edit keeps room for pieces that show natural form rather than a fully polished finish.",
    Soft_Glow_Luminous: "You chose a softer glow, so the edit gives extra weight to gentle sheen and lower-contrast luminosity.",
    Wood_Agarwood_Warm: "You chose wood warmth, so the edit gives extra weight to agarwood, warmer browns, and pieces that feel easier for everyday wear.",
    Intuitive_Eye_Led: "You left the visual direction more open, so the edit keeps more room for instinct and first-eye attraction."
  };

  const DIRECTION_REASON_EN = {
    Clarity: "clearer light and less visual noise",
    Unfolding: "more room, softer movement, and a less compressed feeling",
    Soothing: "a quieter pace and a gentler place for the eye to rest",
    Grounding: "warmer weight, daily steadiness, and a stronger point of contact",
    Protection: "a more contained look with clearer boundaries",
    Courage: "a small spark of forward motion without pushing too hard"
  };

  const PRODUCT_CATALOG = [
    { sku: "FS-BR-2606-001", material: "Garden Quartz, Yellow Garden Quartz, Agarwood", type: "Bracelet", primary: "Grounding", secondary: "Clarity", tags: ["Scenic_Inclusion_World", "Wood_Agarwood_Warm"], avoid: ["too_armor"], price: 199, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-002", material: "Garden Quartz, Agarwood", type: "Bracelet", primary: "Grounding", secondary: "Clarity", tags: ["Scenic_Inclusion_World", "Wood_Agarwood_Warm"], avoid: ["too_armor", "too_heavy"], price: 299, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-003", material: "Clear Quartz, Garden Quartz, Agarwood", type: "Bracelet", primary: "Clarity", secondary: "Grounding", tags: ["Scenic_Inclusion_World", "Clear_Clean_Bright", "Wood_Agarwood_Warm"], avoid: ["too_armor"], price: 199, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-004", material: "Yellow Garden Quartz, Agarwood", type: "Bracelet", primary: "Grounding", secondary: "Courage", tags: ["Scenic_Inclusion_World", "Wood_Agarwood_Warm"], avoid: ["too_armor", "too_heavy"], price: 129, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-005", material: "Clear Quartz, Agarwood", type: "Bracelet", primary: "Clarity", secondary: "Grounding", tags: ["Clear_Clean_Bright", "Wood_Agarwood_Warm"], avoid: ["too_armor", "too_busy"], price: 79, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-006", material: "Rose Quartz, Clear Quartz, Agarwood", type: "Bracelet_Double", primary: "Unfolding", secondary: "Clarity", tags: ["Clear_Clean_Bright", "Soft_Glow_Luminous", "Wood_Agarwood_Warm"], avoid: ["too_busy", "too_scattered"], price: 89, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-007", material: "White Phantom Quartz, Red Sandalwood", type: "Bracelet_Double", primary: "Clarity", secondary: "Grounding", tags: ["Scenic_Inclusion_World", "Wood_Agarwood_Warm"], avoid: ["too_busy", "too_scattered"], price: 159, line: "woodlight", available: "Available" },
    { sku: "FS-BR-2606-008", material: "Shoushan Stone, Turquoise, Golden Tiger Eye, Agarwood", type: "Bracelet_Double", primary: "Grounding", secondary: "Clarity", tags: ["Wood_Agarwood_Warm", "Raw_Cluster_Point"], avoid: [], price: 79, line: "stone-wood-keepsakes", available: "Available" },
    { sku: "FS-NK-2606-001", material: "Bodhi Seed, Golden Tiger Eye, Agarwood", type: "Necklace", primary: "Grounding", secondary: "Protection", tags: ["Wood_Agarwood_Warm"], avoid: [], price: 89, line: "stone-wood-keepsakes", available: "Available" },
    { sku: "FS-BR-2606-009", material: "Silver Sheen Obsidian, Obsidian", type: "Bracelet", primary: "Protection", secondary: "Clarity", tags: ["Raw_Cluster_Point"], avoid: [], price: 149, line: "nocturne-cosmos", available: "Available" },
    { sku: "FS-BR-2606-010", material: "Obsidian, Silver Sheen Obsidian, Kyanite, Smoky Quartz", type: "Bracelet_Double", primary: "Protection", secondary: "Clarity", tags: ["Soft_Glow_Luminous", "Raw_Cluster_Point"], avoid: [], price: 159, line: "nocturne-cosmos", available: "Available" },
    { sku: "FS-BR-2606-011", material: "Obsidian, Silver Sheen Obsidian", type: "Bracelet_Double", primary: "Protection", secondary: "Clarity", tags: ["Raw_Cluster_Point"], avoid: [], price: 89, line: "nocturne-cosmos", available: "Available" },
    { sku: "FS-NK-2606-002", material: "Obsidian, Silver Sheen Obsidian, Blue Tiger Eye, Tiger Eye, Smoky Quartz", type: "Necklace", primary: "Protection", secondary: "Clarity", tags: ["Raw_Cluster_Point"], avoid: [], price: 199, line: "nocturne-cosmos", available: "Available" },
    { sku: "FS-BR-2606-012", material: "Black Rutilated Quartz, Black Silver Titanium Quartz, Silver Sheen Obsidian, Clear Quartz", type: "Bracelet", primary: "Protection", secondary: "Clarity", tags: ["Rutilated_Thread_Light", "Clear_Clean_Bright", "Raw_Cluster_Point"], avoid: ["too_busy", "too_scattered"], price: 299, line: "nocturne-cosmos", available: "Available" },
    { sku: "FS-BR-2606-013", material: "Multicolor Rabbit Hair Quartz", type: "Bracelet", primary: "Unfolding", secondary: "Soothing", tags: ["Rutilated_Thread_Light", "Soft_Glow_Luminous"], avoid: ["too_hot", "too_pushy"], price: 149, line: "cloudsilk", available: "Available" },
    { sku: "FS-BR-2606-014", material: "Super Seven", type: "Bracelet", primary: "Clarity", secondary: "Unfolding", tags: ["Rutilated_Thread_Light"], avoid: ["too_hot"], price: 79, line: "other", available: "Available" },
    { sku: "FS-BR-2606-015", material: "Aquamarine, Moonstone", type: "Bracelet", primary: "Soothing", secondary: "Clarity", tags: ["Soft_Glow_Luminous"], avoid: ["too_hot"], price: 399, line: "moonlit-sea", available: "Available" },
    { sku: "FS-BR-2606-016", material: "Aquamarine, Moonstone, Fluorite", type: "Bracelet", primary: "Soothing", secondary: "Clarity", tags: ["Soft_Glow_Luminous", "Raw_Cluster_Point"], avoid: [], price: 329, line: "moonlit-sea", available: "Available" },
    { sku: "FS-BR-2606-017", material: "Kyanite, Aquamarine, Clear Quartz", type: "Bracelet", primary: "Soothing", secondary: "Clarity", tags: ["Clear_Clean_Bright", "Soft_Glow_Luminous"], avoid: [], price: 299, line: "moonlit-sea", available: "Available" },
    { sku: "FS-NK-2606-003", material: "Aquamarine, Clear Quartz", type: "Necklace", primary: "Soothing", secondary: "Clarity", tags: ["Clear_Clean_Bright", "Soft_Glow_Luminous"], avoid: ["too_bright"], price: 199, line: "moonlit-sea", available: "Available" },
    { sku: "FS-BR-2606-018", material: "Aquamarine, Clear Quartz, Kyanite", type: "Bracelet_Double", primary: "Soothing", secondary: "Clarity", tags: ["Clear_Clean_Bright", "Soft_Glow_Luminous"], avoid: [], price: 179, line: "moonlit-sea", available: "Available" },
    { sku: "FS-BR-2606-019", material: "Kyanite", type: "Bracelet", primary: "Clarity", secondary: "Soothing", tags: ["Soft_Glow_Luminous"], avoid: [], price: 89, line: "moonlit-sea", available: "Available" },
    { sku: "FS-NK-2606-004", material: "Black Gold Super Seven, Clear Quartz, Smoky Quartz, Smoky Quartz, Aquamarine, Kyanite", type: "Necklace", primary: "Clarity", secondary: "Soothing", tags: ["Rutilated_Thread_Light", "Clear_Clean_Bright", "Soft_Glow_Luminous"], avoid: [], price: 109, line: "other", available: "Available" },
    { sku: "FS-BR-2606-020", material: "Red Vein Quartz, Red Garden Quartz, Clear Quartz, Burgundy Mineral Beads (Unconfirmed)", type: "Bracelet", primary: "Courage", secondary: "Unfolding", tags: ["Scenic_Inclusion_World", "Clear_Clean_Bright"], avoid: ["too_hot", "too_pushy"], price: 109, line: "red-vein-light", available: "Available" },
    { sku: "FS-BR-2606-021", material: "Red Garden Quartz, Clear Quartz", type: "Bracelet", primary: "Courage", secondary: "Unfolding", tags: ["Scenic_Inclusion_World", "Clear_Clean_Bright"], avoid: ["too_hot", "too_busy"], price: 79, line: "red-vein-light", available: "Available" },
    { sku: "FS-BR-2606-022", material: "Nanhong Agate, Agarwood", type: "Bracelet", primary: "Grounding", secondary: "Courage", tags: ["Wood_Agarwood_Warm"], avoid: [], price: 179, line: "stone-wood-keepsakes", available: "Available" },
    { sku: "FS-NK-2606-005", material: "Rose Quartz, Clear Quartz", type: "Necklace", primary: "Unfolding", secondary: "Soothing", tags: ["Clear_Clean_Bright", "Soft_Glow_Luminous"], avoid: [], price: 109, line: "rose-mist", available: "Available" },
    { sku: "FS-BR-2606-023", material: "Amethyst", type: "Bracelet", primary: "Clarity", secondary: "Soothing", tags: ["Soft_Glow_Luminous"], avoid: [], price: 79, line: "other", available: "Available" },
    { sku: "FS-NK-2606-006", material: "Clear Quartz Hexagonal Point", type: "Necklace", primary: "Protection", secondary: "Clarity", tags: ["Clear_Clean_Bright", "Raw_Cluster_Point"], avoid: [], price: 149, line: "other", available: "Available" },
    { sku: "FS-TW-2606-001", material: "Green Phantom Quartz, Clear Quartz", type: "Necklace", primary: "Clarity", secondary: "Courage", tags: ["Scenic_Inclusion_World", "Clear_Clean_Bright"], avoid: [], price: 799, line: "three-thousand-worlds", available: "Available" },
    { sku: "FS-TW-2606-002", material: "Green Phantom Quartz, Green Tourmaline, Clear Quartz", type: "Necklace", primary: "Grounding", secondary: "Clarity", tags: ["Scenic_Inclusion_World", "Clear_Clean_Bright"], avoid: [], price: 899, line: "three-thousand-worlds", available: "Available" },
    { sku: "FS-TW-2606-003", material: "Pink Phantom Quartz", type: "Necklace", primary: "Unfolding", secondary: "Clarity", tags: ["Scenic_Inclusion_World"], avoid: [], price: 1199, line: "three-thousand-worlds", available: "Available" },
    { sku: "FS-TW-2606-004", material: "Red Phantom Quartz", type: "Necklace", primary: "Courage", secondary: "Grounding", tags: ["Scenic_Inclusion_World"], avoid: [], price: 999, line: "three-thousand-worlds", available: "Available" },
    { sku: "FS-TW-2606-005", material: "Multicolor Phantom Quartz", type: "Necklace", primary: "Grounding", secondary: "Courage", tags: ["Scenic_Inclusion_World"], avoid: [], price: 999, line: "three-thousand-worlds", available: "Available" },
    { sku: "FS-BR-2606-024", material: "Green Phantom Quartz", type: "Bracelet", primary: "Grounding", secondary: "Protection", tags: ["Scenic_Inclusion_World"], avoid: [], price: 1999, line: "emerald-realm", available: "Available" },
    { sku: "FS-BR-2606-025", material: "Green Phantom Quartz", type: "Bracelet", primary: "Clarity", secondary: "Grounding", tags: ["Scenic_Inclusion_World"], avoid: [], price: 899, line: "emerald-realm", available: "Available" },
    { sku: "FS-BR-2606-026", material: "Sandalwood Tube Beads, Clear Quartz", type: "Bracelet", primary: "Grounding", secondary: "Clarity", tags: ["Clear_Clean_Bright", "Wood_Agarwood_Warm"], avoid: [], price: 79, line: "woodlight", available: "Available" }
  ];

  // The 6 products actually imported into Shopify so far (see
  // migration/products.draft.json). SKUs here do not overlap the legacy
  // PRODUCT_CATALOG above (different numbering scheme) except FS-TW-2606-001.
  // Kept separate on purpose: PRODUCT_CATALOG is the full planned lineup,
  // this is only what customers can actually view/buy right now.
  // Object-type pieces are excluded from automatic matching (private
  // inquiry only, no direct add-to-cart — see website/CLAUDE.md §6).
  const LIVE_PRODUCT_TITLES = {
    "FS-TW-2606-001": "Jinyu Mountain Green Phantom Quartz Necklace",
    "FS-MS-2606-002": "Moonlit Tide Aquamarine Bracelet",
    "FS-MS-2606-003": "Moon Veil Moonstone Necklace",
    "FS-WL-2606-003": "Pine Shadow Garden Quartz Bracelet",
    "FS-NC-2606-004": "Silver Sheen Obsidian Object",
    "FS-NC-2606-005": "Nocturne Spark Quartz Necklace"
  };

  const LIVE_PRODUCT_CATALOG = [
    { sku: "FS-TW-2606-001", material: "Green Phantom Quartz, Titanium Steel", type: "Necklace", primary: "Grounding", secondary: "Clarity", tags: ["Scenic_Inclusion_World", "Clear_Clean_Bright"], avoid: [], price: 799, line: "three-thousand-worlds", available: "Available" },
    { sku: "FS-MS-2606-002", material: "Aquamarine, Moonstone, Titanium Steel", type: "Bracelet", primary: "Soothing", secondary: "Unfolding", tags: ["Soft_Glow_Luminous", "Clear_Clean_Bright"], avoid: [], price: 399, line: "moonlit-sea", available: "Available" },
    { sku: "FS-MS-2606-003", material: "Moonstone, Clear Quartz, Titanium Steel", type: "Necklace", primary: "Soothing", secondary: null, tags: ["Soft_Glow_Luminous", "Clear_Clean_Bright"], avoid: [], price: 549, line: "moonlit-sea", available: "Available" },
    { sku: "FS-WL-2606-003", material: "Garden Quartz, Agarwood, Titanium Steel", type: "Bracelet", primary: "Grounding", secondary: "Clarity", tags: ["Scenic_Inclusion_World", "Wood_Agarwood_Warm"], avoid: [], price: 299, line: "woodlight", available: "Available" },
    { sku: "FS-NC-2606-004", material: "Silver Sheen Obsidian", type: "Object", primary: "Protection", secondary: null, tags: ["Raw_Cluster_Point"], avoid: [], price: null, line: "nocturne-cosmos", available: "Unavailable" },
    { sku: "FS-NC-2606-005", material: "Quartz, Titanium Steel", type: "Necklace", primary: "Courage", secondary: null, tags: ["Clear_Clean_Bright"], avoid: [], price: 149, line: "nocturne-cosmos", available: "Available" }
  ];

  function emptyVector() {
    return Object.fromEntries(STATES.map((state) => [state, 0]));
  }

  function normalize(vector) {
    const total = STATES.reduce((sum, state) => sum + Number(vector[state] || 0), 0);
    if (!total) return emptyVector();
    return Object.fromEntries(STATES.map((state) => [state, Number(vector[state] || 0) / total * 100]));
  }

  function addScores(target, delta) {
    Object.entries(delta || {}).forEach(([state, value]) => {
      if (STATES.includes(state)) target[state] += Number(value || 0);
    });
  }

  function cosine(a, b) {
    const dot = STATES.reduce((sum, state) => sum + Number(a[state] || 0) * Number(b[state] || 0), 0);
    const normA = Math.sqrt(STATES.reduce((sum, state) => sum + Number(a[state] || 0) ** 2, 0));
    const normB = Math.sqrt(STATES.reduce((sum, state) => sum + Number(b[state] || 0) ** 2, 0));
    return normA && normB ? dot / (normA * normB) : 0;
  }

  function deriveMatrix() {
    const columnSums = Object.fromEntries(ELEMENTS.map((element) => [element, STATES.reduce((sum, state) => sum + W_MATRIX[state][element], 0)]));
    return Object.fromEntries(STATES.map((sourceState) => {
      const targetElements = Object.fromEntries(ELEMENTS.map((element) => [element, 0]));
      ELEMENTS.forEach((element) => {
        const amount = W_MATRIX[sourceState][element];
        targetElements[CONTROLLED_BY[element]] += amount * 0.7;
        targetElements[GENERATES[element]] += amount * 1.3;
      });
      const projected = emptyVector();
      ELEMENTS.forEach((element) => {
        if (!targetElements[element] || !columnSums[element]) return;
        STATES.forEach((state) => {
          projected[state] += targetElements[element] * W_MATRIX[state][element] / columnSums[element];
        });
      });
      projected[sourceState] = 0;
      return [sourceState, normalize(projected)];
    }));
  }

  const M_MATRIX = deriveMatrix();

  function applyMatrix(vector) {
    const source = normalize(vector);
    const output = emptyVector();
    STATES.forEach((sourceState) => {
      STATES.forEach((targetState) => {
        output[targetState] += source[sourceState] * M_MATRIX[sourceState][targetState] / 100;
      });
    });
    return normalize(output);
  }

  function zodiacFromDate(value) {
    if (!value) return null;
    const date = new Date(`${value}T12:00:00`);
    if (Number.isNaN(date.getTime())) return null;
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const marker = month * 100 + day;
    if (marker >= 1222 || marker < 120) return "Capricorn";
    if (marker < 219) return "Aquarius";
    if (marker < 321) return "Pisces";
    if (marker < 420) return "Aries";
    if (marker < 521) return "Taurus";
    if (marker < 621) return "Gemini";
    if (marker < 723) return "Cancer";
    if (marker < 823) return "Leo";
    if (marker < 923) return "Virgo";
    if (marker < 1023) return "Libra";
    if (marker < 1122) return "Scorpio";
    return "Sagittarius";
  }

  function seasonFromDate(value) {
    if (!value) return null;
    const date = new Date(`${value}T12:00:00`);
    if (Number.isNaN(date.getTime())) return null;
    const month = date.getMonth() + 1;
    if ([2, 3, 4].includes(month)) return "Wood";
    if ([5, 6, 7].includes(month)) return "Fire";
    if ([8, 9, 10].includes(month)) return "Metal";
    return "Water";
  }

  function topStates(vector, count) {
    return STATES.slice().sort((a, b) => Number(vector[b] || 0) - Number(vector[a] || 0) || STATES.indexOf(a) - STATES.indexOf(b)).filter((state) => Number(vector[state] || 0) > 0).slice(0, count);
  }

  function normalizeEntryMode(value) {
    if (value === "B" || value === "birth_frequency") return "B";
    if (value === "C" || value === "browse_shop" || value === "browse_collection") return "C";
    return "A";
  }

  function canonicalQ2(value) {
    return Q2_SCORES[value] ? value : Q2_ALIAS[value] || null;
  }

  function canonicalQ3(value) {
    return Q3_DATA[value] ? value : Q3_ALIAS[value] || null;
  }

  function q5Vector(q5) {
    const sign = q5.zodiac_sign || q5.zodiac || zodiacFromDate(q5.birth_date);
    const hasLatitude = q5.latitude !== undefined && q5.latitude !== null && q5.latitude !== "" || q5.lat !== undefined && q5.lat !== null && q5.lat !== "";
    const hasLongitude = q5.longitude !== undefined && q5.longitude !== null && q5.longitude !== "" || q5.lon !== undefined && q5.lon !== null && q5.lon !== "";
    const hasPreciseBirth = Boolean(q5.birth_date && q5.birth_time && (q5.birth_city || q5.display_name) && hasLatitude && hasLongitude);
    const hasReportBirthInput = Boolean(q5.birth_date && q5.birth_time && (q5.birth_city || q5.display_name));
    const requestedLevel = hasPreciseBirth ? "L3" : q5.birth_date ? "L2" : sign ? "L1" : "L0";
    if (!sign || !ZODIAC_AFFINITY[sign]) return { level: "L0", requestedLevel, A: emptyVector(), Praw: emptyVector(), qBase: 0 };

    const zodiac = normalize(ZODIAC_AFFINITY[sign]);
    if (!q5.birth_date) {
      return { level: "L1", requestedLevel, l3ReportCandidate: false, sign, A: zodiac, Praw: applyMatrix(zodiac), qBase: 0.1 };
    }

    const season = seasonFromDate(q5.birth_date);
    const seasonVector = normalize(SEASON_VECTORS[season]);
    const seasonWeight = 0.1 + 0.2 * (1 - cosine(zodiac, seasonVector));
    const raw = normalize(Object.fromEntries(STATES.map((state) => [state, (1 - seasonWeight) * zodiac[state] + seasonWeight * seasonVector[state]])));
    const rawTop = topStates(raw, 1)[0];
    const rawPraw = applyMatrix(raw);
    const protectedFallback = rawTop && rawTop === topStates(rawPraw, 1)[0];
    const A = protectedFallback ? zodiac : raw;
    return {
      level: "L2",
      requestedLevel,
      l3ReportCandidate: hasReportBirthInput,
      sign,
      season,
      A,
      Praw: applyMatrix(A),
      qBase: 0.15,
      seasonWeight: protectedFallback ? 0 : seasonWeight
    };
  }

  function processQ1(values) {
    const choices = Array.isArray(values) ? values : [];
    const states = choices.filter((value) => STATES.includes(value)).slice(0, 2);
    const scores = emptyVector();
    if (states.length === 1) scores[states[0]] = 60;
    if (states.length === 2) states.forEach((state) => { scores[state] = 45; });
    return { states, scores, unknown: choices.includes("unknown") };
  }

  function processQ3(value, skipped) {
    const rhythm = canonicalQ3(value);
    if (skipped || !rhythm || !Q3_DATA[rhythm]) return { answered: false, rhythm: null, scores: emptyVector(), expression: {}, safety: "normal", safety_tags: [] };
    const data = Q3_DATA[rhythm];
    const scores = emptyVector();
    addScores(scores, data.scores);
    return { answered: true, rhythm, scores, expression: data.expression, safety: data.safety, safety_tags: data.safety_tags || [] };
  }

  function rankStates(vector) {
    const ranked = topStates(vector, 2);
    if (!ranked.length) return { primary: null, secondary: null, ratio: null, dual: false };
    const primary = ranked[0];
    const candidate = ranked[1] || null;
    const ratio = candidate ? vector[candidate] / vector[primary] : 0;
    return { primary, secondary: ratio >= 0.5 ? candidate : null, ratio, dual: Boolean(candidate && ratio >= 0.5) };
  }

  function recommendationHeadline(primary, q4) {
    if (!primary) return "保留更多眼缘空间，让作品本身的光感、质地与第一眼停留来带路。";
    const firstSpecific = (q4 || []).find((tag) => tag !== "Intuitive_Eye_Led");
    return firstSpecific && AESTHETIC_HEADLINE[firstSpecific]
      ? `${AESTHETIC_HEADLINE[firstSpecific]}，${STATE_HEADLINE[primary]}`
      : STATE_HEADLINE[primary];
  }

  function aestheticReason(q4) {
    const tags = Array.isArray(q4) ? q4 : [];
    if (tags.includes("Intuitive_Eye_Led")) return AESTHETIC_REASON.Intuitive_Eye_Led;
    const reasons = tags.map((tag) => AESTHETIC_REASON[tag]).filter(Boolean).slice(0, 2);
    return reasons.length ? reasons.join(" ") : "这次没有把审美方向限定得很窄，所以推荐会先保留更多眼缘空间，再由作品本身的光感、质地和状态贴近度来排序。";
  }

  function alphaRelation(alpha) {
    if (alpha >= 0.7) return "resonance";
    if (alpha > 0.3) return "integration";
    return "balance";
  }

  function natalReason(level, geometry) {
    if (level === "L0" || !geometry || geometry.q_eff <= 0) return null;
    const prefix = level === "L1" ? "提供的星座信息只做轻量参考" : "出生日期带来一点季节与太阳星座的底色";
    const relation = geometry.alpha_relation;
    const bodies = {
      resonance: "它和这次当下方向比较顺，所以推荐会顺着这条路走，不把你推向一个陌生方向。",
      integration: "它和这次当下方向不完全重合，所以推荐仍以此刻状态为主，只在光感、温度和佩戴感里做一点轻调。",
      balance: "它在这次推荐里更像一层底色，不抢当下方向；作品会保留更温和的平衡感。"
    };
    return `${prefix}；${bodies[relation] || bodies.balance}`;
  }

  function recommendationHeadlineEn(primary, q4) {
    if (!primary) return "A looser edit led by material, texture, and first instinct.";
    const firstSpecific = (q4 || []).find((tag) => tag !== "Intuitive_Eye_Led");
    return firstSpecific && AESTHETIC_LABEL_EN[firstSpecific]
      ? `${AESTHETIC_LABEL_EN[firstSpecific]}, with a ${STATE_LABEL_EN[primary]} direction.`
      : `Pieces selected for a ${STATE_LABEL_EN[primary]} direction.`;
  }

  function resultSummaryEn(primary, secondary) {
    if (!primary) {
      return "Your answers keep the direction intentionally open. The edit gives more room to material, texture, and the first piece you want to keep looking at.";
    }
    const base = STATE_SUMMARY_EN[primary] || "";
    if (!secondary) return base;
    const secondaryReason = DIRECTION_REASON_EN[secondary] || `${STATE_LABEL_EN[secondary].toLowerCase()} support`;
    return `${base} A secondary ${STATE_LABEL_EN[secondary]} note adds ${secondaryReason}.`;
  }

  function aestheticReasonEn(q4) {
    const tags = Array.isArray(q4) ? q4 : [];
    if (tags.includes("Intuitive_Eye_Led")) return AESTHETIC_REASON_EN.Intuitive_Eye_Led;
    const reasons = tags.map((tag) => AESTHETIC_REASON_EN[tag]).filter(Boolean).slice(0, 2);
    return reasons.length
      ? reasons.join(" ")
      : "The visual direction is not narrowed too tightly, so the edit keeps room for first-eye attraction while still using the state match as a guide.";
  }

  function natalReasonEn(level, geometry) {
    if (level === "L0" || !geometry || geometry.q_eff <= 0) return null;
    const prefix = level === "L1"
      ? "The zodiac sign is used only as a light reference."
      : "The birth date adds a small seasonal and zodiac reference.";
    const bodies = {
      resonance: "It lines up with the current direction, so the edit can follow that path without pushing the result somewhere unfamiliar.",
      integration: "It does not fully overlap with the current direction, so the edit keeps the current-state answers first and only tunes material, color, and wearing feel.",
      balance: "It stays in the background of the match, adding a soft balancing note rather than replacing the current-state direction."
    };
    return `${prefix} ${bodies[geometry.alpha_relation] || bodies.balance}`;
  }

  function directionTextEn(states) {
    if (!states.length) {
      return "The long-term reference does not point to one fixed state, so the best next step is to start with color, material, and the piece that holds your attention.";
    }
    if (states.length === 1) {
      const state = states[0];
      return `Start with ${STATE_LABEL_EN[state]}. This is a direction to explore, not a definition of who you are.`;
    }
    const [first, second] = states;
    return `Start with ${STATE_LABEL_EN[first]} and ${STATE_LABEL_EN[second]}. One side leans toward ${DIRECTION_REASON_EN[first]}, while the other adds ${DIRECTION_REASON_EN[second]}.`;
  }

  function formatProductType(type) {
    if (!type) return "Piece";
    if (type === "Bracelet_Double") return "Double Bracelet";
    return type.replace(/_/g, " ");
  }

  function productTitle(product) {
    const materials = String(product.material || "").split(",").map((item) => item.trim()).filter(Boolean);
    const heroMaterials = materials.length > 1 ? `${materials[0]} & ${materials[1]}` : materials[0] || "Natural Stone";
    return `${heroMaterials} ${formatProductType(product.type)}`;
  }

  // Per-card "why this one" (P3, path b): assembled from the piece's aesthetic
  // lead + material warmth + a state-fit clause. Writes texture / light / wearing
  // feel (FS_Match_Copy §3.3) and varies card-to-card instead of one template.
  // Adjective form of each aesthetic, so it can sit after the material name.
  const AESTHETIC_DESCRIPTOR_EN = {
    Clear_Clean_Bright: "clear and unclouded",
    Scenic_Inclusion_World: "with scenery held inside",
    Rutilated_Thread_Light: "threaded with light",
    Raw_Cluster_Point: "close to raw form",
    Soft_Glow_Luminous: "soft-lit",
    Wood_Agarwood_Warm: "warm-grained",
    Intuitive_Eye_Led: "quietly composed"
  };
  const STATE_SETTLE_EN = {
    Clarity: "an easy, uncluttered read",
    Unfolding: "room to loosen and open",
    Soothing: "somewhere quiet to rest the eye",
    Grounding: "steady, and easy to stay with",
    Protection: "contained, with a clear edge",
    Courage: "a small, warm pull forward"
  };

  function productFitText(product, q4) {
    const tags = product.tags || [];
    // Lead with the piece's own material (differs per SKU, so cards never repeat),
    // then the aesthetic the user chose, then a state-fit clause.
    const materialLead = String(product.material || "")
      .split(",").map((m) => m.trim()).filter(Boolean).slice(0, 2).join(" & ");
    const matching = tags.filter((tag) => (q4 || []).includes(tag));
    const lead = matching[0] || tags[0];
    const descriptor = (lead && AESTHETIC_DESCRIPTOR_EN[lead]) || "quietly composed";
    const settle = STATE_SETTLE_EN[product.primary] || "an easy piece to settle into";
    return materialLead
      ? `${materialLead}, ${descriptor} — ${settle}.`
      : `${descriptor.charAt(0).toUpperCase()}${descriptor.slice(1)} — ${settle}.`;
  }

  function productScore(product, vector, q4, safetyMode) {
    const primaryScore = Number(vector[product.primary] || 0);
    const secondaryScore = Number(vector[product.secondary] || 0);
    const tagScore = (product.tags || []).reduce((sum, tag) => sum + ((q4 || []).includes(tag) ? 18 : 0), 0);
    const lineDiversity = product.line === "other" ? 0 : 2;
    const safetyPenalty = safetyMode === "conservative" ? (product.avoid || []).length * 5 : 0;
    return primaryScore * 1.2 + secondaryScore * 0.55 + tagScore + lineDiversity - safetyPenalty;
  }

  function hasLargePriceSpan(products) {
    const prices = products.map((product) => Number(product.price || 0)).filter((price) => price > 0).sort((a, b) => a - b);
    if (prices.length < 2) return false;
    const min = prices[0];
    const max = prices[prices.length - 1];
    return max >= 500 && max / min >= 4;
  }

  function curatePriceCohort(rankedProducts) {
    const firstThree = rankedProducts.slice(0, 3);
    if (firstThree.length < 3 || !hasLargePriceSpan(firstThree)) return firstThree;

    const accessibleCandidates = rankedProducts.filter((product) => Number(product.price || 0) < 500);
    if (accessibleCandidates.length >= 3) {
      return accessibleCandidates.slice(0, 3);
    }

    const collectorCandidates = rankedProducts.filter((product) => Number(product.price || 0) >= 500);
    if (collectorCandidates.length >= 3) {
      return collectorCandidates.slice(0, 3);
    }

    return firstThree.slice().sort((a, b) => {
      const aCollector = Number(a.price || 0) >= 500 ? 1 : 0;
      const bCollector = Number(b.price || 0) >= 500 ? 1 : 0;
      return aCollector - bCollector || b.score - a.score;
    });
  }

  function recommendProducts(vector, q4, safetyMode) {
    const sourceVector = vector && topStates(vector, 1).length ? vector : Object.fromEntries(STATES.map((state) => [state, 1]));
    const rankedProducts = LIVE_PRODUCT_CATALOG
      .filter((product) => product.available === "Available")
      .map((product) => ({
        ...product,
        score: productScore(product, sourceVector, q4, safetyMode),
        title: LIVE_PRODUCT_TITLES[product.sku] || productTitle(product),
        type_label: formatProductType(product.type),
        price_label: `$${Number(product.price || 0).toLocaleString("en-US")}.00`,
        state_label: STATE_LABEL_EN[product.primary] || product.primary,
        secondary_label: STATE_LABEL_EN[product.secondary] || product.secondary,
        fit_note: productFitText(product, q4)
      }))
      .sort((a, b) => b.score - a.score || a.price - b.price || a.sku.localeCompare(b.sku));
    return curatePriceCohort(rankedProducts);
  }

  function directionText(states) {
    if (!states.length) return "你的长期频率没有把方向推向单一状态，所以这次更适合把选择权交还给眼缘。你可以先从颜色、材质和第一眼的喜欢开始看。";
    if (states.length === 1) {
      const state = states[0];
      return `这一次，可以先从「${STATE_CN[state]}」这个方向开始看。它不是在定义你，而是在提示：这些作品可能更适合作为一个入口。`;
    }
    const [first, second] = states;
    return `这一次，可以先从「${STATE_CN[first]}」和「${STATE_CN[second]}」两个方向开始看。它们不是对你的定论，而是两个可以探索的入口：一个更靠近${DIRECTION_REASON[first]}，一个更靠近${DIRECTION_REASON[second]}。`;
  }

  function runMatch(answers) {
    const entryMode = normalizeEntryMode(answers.entry_mode);
    const birthDetails = answers.birth_details || answers.q5 || {};
    const q5 = q5Vector(birthDetails);

    if (entryMode === "C") {
      return { entry_mode: "C", product_cards: recommendProducts(null, [], "normal") };
    }

    if (entryMode === "B") {
      const directions = topStates(q5.Praw, 2);
      const q4 = Array.isArray(answers.aesthetic_preferences || answers.q4) ? (answers.aesthetic_preferences || answers.q4) : [];
      return {
        entry_mode: "B",
        direction_states: directions,
        direction_text: directionText(directions),
        direction_text_en: directionTextEn(directions),
        frequency_line_en: directions.length ? directions.map((state) => STATE_LABEL_EN[state]).join(" + ") : "Open direction",
        recommendation_headline_en: recommendationHeadlineEn(directions[0], q4),
        summary_text_en: directionTextEn(directions),
        reason_blocks_en: {
          current_frequency: "This path begins from the birth-frequency reference rather than the full current-state quiz.",
          aesthetic_preference: aestheticReasonEn(q4),
          natal_frequency: directions.length ? directionTextEn(directions) : null
        },
        q5_input_level: q5.level,
        q5_requested_level: q5.requestedLevel,
        q5_geometry: { alpha: 0, q_eff: q5.level === "L0" ? 0 : 1, alpha_relation: "entry_b" },
        final_state_vector: q5.Praw,
        product_cards: recommendProducts(q5.Praw, q4, "normal")
      };
    }

    const desiredState = answers.desired_state || answers.q1 || [];
    const lifeContext = canonicalQ2(answers.life_context || answers.q2);
    const currentRhythm = canonicalQ3(answers.current_rhythm || answers.q3);
    const aestheticPreferences = answers.aesthetic_preferences || answers.q4 || [];
    const q1 = processQ1(desiredState);
    const q3 = processQ3(currentRhythm, answers.q3_skipped || answers.current_rhythm_skipped);
    const scores = emptyVector();
    addScores(scores, q1.scores);
    addScores(scores, Q2_SCORES[lifeContext] || {});
    addScores(scores, q3.scores);
    const current = normalize(scores);
    let finalVector = current;
    let geometry = { alpha: null, q_eff: 0, alpha_relation: "none" };

    if (q5.level !== "L0" && topStates(current, 1).length) {
      const sA = cosine(current, q5.A);
      const sP = cosine(current, q5.Praw);
      const alpha = sA + sP ? sA / (sA + sP) : 0.5;
      const qEff = q5.qBase * Math.min(1, sA + sP);
      const tuning = Object.fromEntries(STATES.map((state) => [state, alpha * q5.A[state] + (1 - alpha) * q5.Praw[state]]));
      finalVector = normalize(Object.fromEntries(STATES.map((state) => [state, (1 - qEff) * current[state] + qEff * tuning[state]])));
      geometry = { alpha, q_eff: qEff, alpha_relation: alphaRelation(alpha) };
    }

    const stateResult = rankStates(finalVector);
    const verseSecondary = stateResult.secondary || stateResult.primary;
    const verse = stateResult.primary ? VERSES[`${stateResult.primary}|${verseSecondary}`] : null;
    const q4 = Array.isArray(aestheticPreferences) ? aestheticPreferences : [];
    const frequencyLine = stateResult.primary
      ? `${STATE_CN[stateResult.primary]}${stateResult.secondary ? ` × ${STATE_CN[stateResult.secondary]}` : ""}`
      : null;
    const frequencyLineEn = stateResult.primary
      ? `${STATE_LABEL_EN[stateResult.primary]}${stateResult.secondary ? ` + ${STATE_LABEL_EN[stateResult.secondary]}` : ""}`
      : "Open direction";

    return {
      entry_mode: "A",
      primary_state: stateResult.primary,
      secondary_state: stateResult.secondary,
      is_dual_state: stateResult.dual,
      secondary_ratio: stateResult.ratio,
      verse_number: verse ? verse[0] : null,
      verse_text: verse ? verse[1] : null,
      verse_text_en: verse ? VERSE_TEXT_EN[verse[0]] || null : null,
      frequency_line: frequencyLine,
      frequency_line_en: frequencyLineEn,
      summary_text_en: resultSummaryEn(stateResult.primary, stateResult.secondary),
      recommendation_headline: recommendationHeadline(stateResult.primary, q4),
      recommendation_headline_en: recommendationHeadlineEn(stateResult.primary, q4),
      reason_blocks: {
        current_frequency: stateResult.primary ? CURRENT_REASON[stateResult.primary] : "这次没有把状态方向判得很窄，所以作品会先保持柔和、开放，让眼缘替你完成下一步选择。",
        aesthetic_preference: aestheticReason(q4),
        natal_frequency: natalReason(q5.level, geometry)
      },
      reason_blocks_en: {
        current_frequency: stateResult.primary ? CURRENT_REASON_EN[stateResult.primary] : "The state direction stays open, so the edit keeps the match softer and lets material, texture, and first-eye response do more of the work.",
        aesthetic_preference: aestheticReasonEn(q4),
        natal_frequency: natalReasonEn(q5.level, geometry)
      },
      q2_context_id: lifeContext === "prefer_not_to_say" ? null : lifeContext,
      q2_context: lifeContext === "prefer_not_to_say" ? null : lifeContext,
      q3_rhythm_id: q3.rhythm,
      q3_rhythm: q3.rhythm,
      q3_answered: q3.answered,
      q3_safety_tags: q3.safety_tags,
      q4_aesthetic: q4,
      q4_eye_based: q4.includes("Intuitive_Eye_Led"),
      q5_input_level: q5.level,
      q5_requested_level: q5.requestedLevel,
      q5_geometry: geometry,
      final_state_vector: finalVector,
      safety_mode: q3.safety,
      expression: q3.expression,
      product_cards: recommendProducts(finalVector, q4, q3.safety)
    };
  }

  window.FSMatchEngine = { STATES, STATE_CN, STATE_LABEL_EN, runMatch };
}());
